import _ from 'lodash'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const mapFieldProfileFilter = (item) => {
  return {
    id: item?.profile_id,
    name: item?.profile_name,
  }
}

export const getProfileFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/profile',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldProfileFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
